// extracted by mini-css-extract-plugin
module.exports = {"root":"root-B8psS"};